import { useEffect } from "react";
import fetchUserData from "../Main/fetchUserData";

const useMembershipCheck = () => {
  useEffect(() => {
    const alreadyChecked = sessionStorage.getItem("membershipChecked");
    if (alreadyChecked) return;

    const checkMembership = async () => {
      try {
        const data = await fetchUserData();

        const latestMembership = data.memberships?.[data.memberships.length - 1];
        const hasValidSubscription = !!latestMembership?.subscription_id;

        localStorage.setItem("usermembership", hasValidSubscription ? "true" : "false");
        sessionStorage.setItem("membershipChecked", "true");
      } catch (error) {
        console.error("Error checking user membership:", error);
        localStorage.setItem("usermembership", "false");
        sessionStorage.setItem("membershipChecked", "true");
      }
    };

    checkMembership();
  }, []); // Run once on mount
};

export default useMembershipCheck;
